import React from 'react';
const AuthContext = React.createContext({});
export { AuthContext };
//# sourceMappingURL=Auth.js.map